export default __webpack_public_path__ + "static/media/campaign-approved-bg.cca07aff.jpg";